import React, { useEffect, useState } from 'react';

import Slab from '../../../helpers/slab/Slab';
import Files from './../../creates/file/Files';
import Audit from '../generic/Audit';
import Get from '../../../api/internal/Get';
import Summary from './Summary';
import Admin from './Admin';
import { useRoleAuthorization } from '../../../hooks/useRoleAuthorization';
import { ADMIN_AUTHORIZED_ROLES } from '../../../auth/AuthRoles';
import { ComchekDataObject } from '../../../interfaces/comchek';

function ComchekSlab({
  comchekId,
  expressCheckNumber,
  startPage,
}: {
  comchekId: number;
  expressCheckNumber: string;
  startPage?: string;
}) {
  const [currentPage, setCurrentPage] = useState();
  const [comchekDataObject] = useState<ComchekDataObject>({
    Admin: null,
    Audit: null,
    Files: null,
    Summary: null,
  });

  useEffect(() => {
    startPage ? HandlePageChange(startPage) : HandlePageChange('Summary');
  }, []);

  function HandlePageChange(params) {
    if (!comchekDataObject[params] && pages[params]?.callerPath) {
      if (Array.isArray(pages[params].callerPath)) {
        let dataObj = {};
        let attributeList = [];
        for (let i = 0; i < pages[params].callerPath.length; i++) {
          attributeList.push(i + 1);
          Get(pages[params].callerPath[i]).then(response => {
            if (response) {
              dataObj[i + 1] = response.data;
              if (HasAllAttributes(dataObj, attributeList)) {
                comchekDataObject[params] = dataObj;
                AssignPages();
                setCurrentPage(params);
              }
            }
          });
        }
      } else {
        Get(pages[params].callerPath).then(response => {
          if (response) {
            comchekDataObject[params] = response.data;
          }
          AssignPages();
          setCurrentPage(params);
        });
      }
    } else {
      setCurrentPage(params);
    }

    function HasAllAttributes(obj, attributeList) {
      for (const attribute of attributeList) {
        if (!obj.hasOwnProperty(attribute)) {
          return false;
        }
      }
      return true;
    }
  }

  function RefreshPage(currentPage: string, additionalPages: string[]) {
    if (comchekDataObject) {
      setCurrentPage(null);
      comchekDataObject[currentPage] = null;
      additionalPages?.forEach(pageName => {
        comchekDataObject[pageName] = null;
      });
      HandlePageChange(currentPage);
    }
  }

  let pages = {};
  AssignPages();
  function AssignPages() {
    pages = {
      Summary: {
        content: <Summary data={comchekDataObject.Summary} />,
        callerPath: `/Comchek/GetComchekSummary/${comchekId}`,
      },
      Files: {
        content: (
          <Files
            fileCategory={'comchek'}
            categoryId={comchekId}
            data={comchekDataObject.Files}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/File/GetAllFiles/comchek-${comchekId}`,
      },
      Audit: {
        content: <Audit data={comchekDataObject.Audit} />,
        callerPath: `/Comchek/GetComchekAudits/${comchekId}`,
      },
    };
    if (useRoleAuthorization(ADMIN_AUTHORIZED_ROLES))
      pages['Admin'] = {
        content: (
          <Admin
            data={comchekDataObject.Admin}
            comchekId={comchekId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Comchek/GetComchekAdmin/${comchekId}`,
      };
  }

  return (
    <Slab
      title={<> Comchek - {expressCheckNumber}</>}
      pages={pages}
      currentPage={currentPage}
      HandlePageChange={HandlePageChange}
      dataObject={comchekDataObject}
    />
  );
}
export default ComchekSlab;
